/**
 * Route for `igaming-s2s-pipeline`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingS2sPipelinePage } from "../features/igaming-s2s-pipeline/IgamingS2sPipelinePage";

export const igamingS2sPipelineRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-s2s-pipeline",
	component: IgamingS2sPipelinePage,
});

export default igamingS2sPipelineRoute;
